import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";

// =========================================
// CSS IMPORT (alag file)
// =========================================
import "./editLabDetails.css";

const EditLabDetails = ({
  labDetails = {},
  onChange,
  onSubmit,
  isAdmin = false,
}) => {
  const [localLabDetails, setLocalLabDetails] = useState({
    labName: "",
    address: "",
    address2: "",
    country: "",
    city: "",
    telephone: "",
    utc: "",
    stateProvince: "",
    zipCode: "",
    email: "",
    subdomain: "",
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (labDetails && Object.keys(labDetails).length > 0) {
      setLocalLabDetails({
        labName: labDetails.labName || "",
        address: labDetails.address || "",
        address2: labDetails.address2 || "",
        country: labDetails.country || "",
        city: labDetails.city || "",
        telephone: labDetails.telephone || "",
        utc: labDetails.utc || labDetails.timeZone || "",
        stateProvince: labDetails.stateProvince || labDetails.state || "",
        zipCode: labDetails.zipCode || labDetails.zipPostal || "",
        email: labDetails.email || labDetails.labEmail || "",
        subdomain: labDetails.subdomain || "",
      });
    }
  }, [labDetails]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    const updatedDetails = {
      ...localLabDetails,
      [name]: value,
    };

    setLocalLabDetails(updatedDetails);

    if (onChange) {
      onChange(updatedDetails);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (localLabDetails.email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailRegex.test(localLabDetails.email)) {
        toast.warning("Please enter a valid email address!", {
          position: "top-center",
          autoClose: 3000,
        });
        return;
      }
    }

    if (onSubmit) {
      setLoading(true);

      try {
        await onSubmit({
          labDetails: localLabDetails,
        });

        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error in lab details submit:", error);
      }
    }
  };

  return (
    <div className="edit-lab-details-wrapper">
      <h1 className="edit-lab-details-title">
        Lab Details
      </h1>

      <div className="edit-lab-details-box">
        <form onSubmit={handleSubmit}>
          <div className="edit-lab-details-form-inner">

            {/* Lab Name */}
            <div className="edit-lab-details-row">
              <label className="edit-lab-details-label">
                Lab Name
              </label>

              <input
                type="text"
                name="labName"
                value={localLabDetails.labName}
                onChange={handleInputChange}
                className="edit-lab-details-input"
              />
            </div>

            {/* Address */}
            <div className="edit-lab-details-row">
              <label className="edit-lab-details-label">
                Address
              </label>

              <input
                type="text"
                name="address"
                value={localLabDetails.address}
                onChange={handleInputChange}
                className="edit-lab-details-input"
              />
            </div>

            {/* Address 2 */}
            <div className="edit-lab-details-row">
              <label className="edit-lab-details-label">
                Address 2{" "}
                <span className="edit-lab-details-optional">
                  (Optional)
                </span>
              </label>

              <input
                type="text"
                name="address2"
                value={localLabDetails.address2}
                onChange={handleInputChange}
                className="edit-lab-details-input"
              />
            </div>

            {/* Country */}
            <div className="edit-lab-details-row">
              <label className="edit-lab-details-label">
                Country
              </label>

              <input
                type="text"
                name="country"
                value={localLabDetails.country}
                onChange={handleInputChange}
                className="edit-lab-details-input"
              />
            </div>

            {/* City */}
            <div className="edit-lab-details-row">
              <label className="edit-lab-details-label">
                City
              </label>

              <input
                type="text"
                name="city"
                value={localLabDetails.city}
                onChange={handleInputChange}
                className="edit-lab-details-input"
              />
            </div>

            {/* State / Province */}
            <div className="edit-lab-details-row">
              <label className="edit-lab-details-label">
                State / Province
              </label>

              <input
                type="text"
                name="stateProvince"
                value={localLabDetails.stateProvince}
                onChange={handleInputChange}
                className="edit-lab-details-input"
              />
            </div>

            {/* Zip / Postal Code */}
            <div className="edit-lab-details-row">
              <label className="edit-lab-details-label">
                Zip / Postal Code
              </label>

              <input
                type="text"
                name="zipCode"
                value={localLabDetails.zipCode}
                onChange={handleInputChange}
                className="edit-lab-details-input"
              />
            </div>

            {/* Telephone */}
            <div className="edit-lab-details-row">
              <label className="edit-lab-details-label">
                Telephone
              </label>

              <input
                type="tel"
                name="telephone"
                value={localLabDetails.telephone}
                onChange={handleInputChange}
                className="edit-lab-details-input"
                placeholder="e.g., +1 234 567 8900"
              />
            </div>

            {/* UTC */}
            <div className="edit-lab-details-row">
              <label className="edit-lab-details-label">
                UTC
              </label>

              <input
                type="text"
                name="utc"
                value={localLabDetails.utc}
                onChange={handleInputChange}
                className="edit-lab-details-input"
                placeholder="e.g., UTC+5"
              />
            </div>

            {/* Lab Email */}
            <div className="edit-lab-details-row">
              <label className="edit-lab-details-label">
                Lab Email
              </label>

              <input
                type="email"
                name="email"
                value={localLabDetails.email}
                onChange={handleInputChange}
                className="edit-lab-details-input"
                placeholder="lab@example.com"
              />
            </div>

            {/* Subdomain - Admin Only */}
            {isAdmin && (
              <div className="edit-lab-details-row edit-lab-details-subdomain-row">
                <label className="edit-lab-details-label">
                  Subdomain
                </label>

                <input
                  type="text"
                  name="subdomain"
                  value={localLabDetails.subdomain}
                  onChange={handleInputChange}
                  className="edit-lab-details-input edit-lab-details-subdomain-input"
                  placeholder="e.g., mylab"
                />

                <small className="edit-lab-details-subdomain-text">
                  .yourdomain.com
                </small>
              </div>
            )}
          </div>

          {/* Save Button */}
          <div className="edit-lab-details-save-wrapper mt-3">
            <button
              type="submit"
              className="btn btn-primary edit-lab-details-save-button"
              disabled={loading}
            >
              {loading ? "Saving..." : "Save Lab Details"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditLabDetails;